import axios from 'axios';
import {
  LOCATION_LIST_REQUEST,
  LOCATION_LIST_SUCCESS,
  LOCATION_LIST_FAIL,
  LOCATION_DETAILS_REQUEST,
  LOCATION_DETAILS_SUCCESS,
  LOCATION_DETAILS_FAIL,
  LOCATION_CREATE_REQUEST,
  LOCATION_CREATE_SUCCESS,
  LOCATION_CREATE_FAIL,
  LOCATION_UPDATE_REQUEST,
  LOCATION_UPDATE_SUCCESS,
  LOCATION_UPDATE_FAIL,
  LOCATION_DELETE_REQUEST,
  LOCATION_DELETE_SUCCESS,
  LOCATION_DELETE_FAIL,
  LOCATION_DELETE_RESET,
  CLUB_ACCESS_STATUS,
  CLUB_INACTIVE_CODE,
  VENUE_LIST_REQUEST,
  VENUE_LIST_SUCCESS,
  VENUE_LIST_FAIL,
  VENUE_CREATE_REQUEST,
  VENUE_CREATE_SUCCESS,
  VENUE_CREATE_FAIL,
  VENUE_ADD_CLUB_REQUEST,
  VENUE_ADD_CLUB_SUCCESS,
  VENUE_ADD_CLUB_FAIL,
  CLUB_LIST_REQUEST,
  CLUB_LIST_SUCCESS,
  CLUB_LIST_FAIL,
  CLUB_DETAILS_REQUEST,
  CLUB_DETAILS_SUCCESS,
  CLUB_DETAILS_FAIL,
  CLUB_CREATE_REQUEST,
  CLUB_CREATE_SUCCESS,
  CLUB_CREATE_FAIL,
  CLUB_UPDATE_REQUEST,
  CLUB_UPDATE_SUCCESS,
  CLUB_UPDATE_FAIL,
  CLUB_DELETE_REQUEST,
  CLUB_DELETE_SUCCESS,
  CLUB_DELETE_FAIL,
  CLUB_STATS_REQUEST,
  CLUB_STATS_SUCCESS,
  CLUB_STATS_FAIL,
  CLUB_ASSIGN_ADMIN_REQUEST,
  CLUB_ASSIGN_ADMIN_SUCCESS,
  CLUB_ASSIGN_ADMIN_FAIL,
  SET_SELECTED_CLUB,
  CLEAR_SELECTED_CLUB,
  // Chip Inventory
  CHIP_INVENTORY_REQUEST,
  CHIP_INVENTORY_SUCCESS,
  CHIP_INVENTORY_FAIL,
  CHIP_INVENTORY_SETUP_REQUEST,
  CHIP_INVENTORY_SETUP_SUCCESS,
  CHIP_INVENTORY_SETUP_FAIL,
  CHIP_INVENTORY_ADD_REQUEST,
  CHIP_INVENTORY_ADD_SUCCESS,
  CHIP_INVENTORY_ADD_FAIL,
  CHIP_INVENTORY_REMOVE_REQUEST,
  CHIP_INVENTORY_REMOVE_SUCCESS,
  CHIP_INVENTORY_REMOVE_FAIL,
  CHIP_INVENTORY_HISTORY_REQUEST,
  CHIP_INVENTORY_HISTORY_SUCCESS,
  CHIP_INVENTORY_HISTORY_FAIL,
  CHIP_INVENTORY_SUMMARY_REQUEST,
  CHIP_INVENTORY_SUMMARY_SUCCESS,
  CHIP_INVENTORY_SUMMARY_FAIL,
  CHIP_INVENTORY_RECONCILE_REQUEST,
  CHIP_INVENTORY_RECONCILE_SUCCESS,
  CHIP_INVENTORY_RECONCILE_FAIL,
} from '../constants/clubConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// ==================== LOCATION ACTIONS ====================

export const listVenues = (params = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: VENUE_LIST_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params,
    };

    const { data } = await axios.get(`${API_URL}/venues`, config);

    dispatch({
      type: VENUE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: VENUE_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const createVenue = (venueData) => async (dispatch, getState) => {
  try {
    dispatch({ type: VENUE_CREATE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(`${API_URL}/venues`, venueData, config);

    dispatch({
      type: VENUE_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: VENUE_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const addClubToVenue = (venueId, clubData) => async (dispatch, getState) => {
  try {
    dispatch({ type: VENUE_ADD_CLUB_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(`${API_URL}/venues/${venueId}/clubs`, clubData, config);

    dispatch({
      type: VENUE_ADD_CLUB_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: VENUE_ADD_CLUB_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// List locations
export const listLocations = (params = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOCATION_LIST_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params,
    };

    const { data } = await axios.get(`${API_URL}/locations`, config);

    dispatch({
      type: LOCATION_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LOCATION_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get location details
export const getLocationDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOCATION_DETAILS_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.get(`${API_URL}/locations/${id}`, config);

    dispatch({
      type: LOCATION_DETAILS_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: LOCATION_DETAILS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Create location
export const createLocation = (locationData) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOCATION_CREATE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/locations`,
      locationData,
      config
    );

    dispatch({
      type: LOCATION_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LOCATION_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Update location
export const updateLocation = (id, locationData) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOCATION_UPDATE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `${API_URL}/locations/${id}`,
      locationData,
      config
    );

    dispatch({
      type: LOCATION_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LOCATION_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Deactivate location by default; permanently delete when options.hardDelete=true.
export const deleteLocation = (id, options = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOCATION_DELETE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params: {
        hardDelete: options.hardDelete === true,
      },
    };

    const { data } = await axios.delete(`${API_URL}/locations/${id}`, config);

    dispatch({
      type: LOCATION_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LOCATION_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const resetLocationDelete = () => ({ type: LOCATION_DELETE_RESET });

// ==================== CLUB ACTIONS ====================

// List clubs
export const listClubs = (params = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLUB_LIST_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params,
    };

    const { data } = await axios.get(`${API_URL}/clubs`, config);

    dispatch({
      type: CLUB_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLUB_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get club details
export const getClubDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLUB_DETAILS_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.get(`${API_URL}/clubs/${id}`, config);

    dispatch({
      type: CLUB_DETAILS_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CLUB_DETAILS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Create club
export const createClub = (clubData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLUB_CREATE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(`${API_URL}/clubs`, clubData, config);

    dispatch({
      type: CLUB_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLUB_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Update club
export const updateClub = (id, clubData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLUB_UPDATE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.put(`${API_URL}/clubs/${id}`, clubData, config);

    dispatch({
      type: CLUB_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLUB_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Delete club (soft deactivation by default, hard delete when options.hardDelete=true)
export const deleteClub = (id, options = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLUB_DELETE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params: {
        hardDelete: options.hardDelete === true,
      },
    };

    const { data } = await axios.delete(`${API_URL}/clubs/${id}`, config);

    dispatch({
      type: CLUB_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLUB_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get club stats
export const getClubStats = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLUB_STATS_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.get(`${API_URL}/clubs/${id}/stats`, config);

    dispatch({
      type: CLUB_STATS_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CLUB_STATS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Assign admin to club
export const assignAdminToClub = (clubId, adminId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLUB_ASSIGN_ADMIN_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/clubs/${clubId}/assign-admin`,
      { adminId },
      config
    );

    dispatch({
      type: CLUB_ASSIGN_ADMIN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CLUB_ASSIGN_ADMIN_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Set selected club for filtering
export const setSelectedClub = (clubId) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_CLUB,
    payload: clubId,
  });

  // Store in localStorage
  if (clubId) {
    localStorage.setItem('selectedClub', clubId);
  } else {
    localStorage.removeItem('selectedClub');
  }
};

// Clear selected club
export const clearSelectedClub = () => (dispatch) => {
  dispatch({ type: CLEAR_SELECTED_CLUB });
  localStorage.removeItem('selectedClub');
};

// ==================== CHIP INVENTORY ACTIONS ====================

// Get chip inventory for a club
export const getChipInventory = (clubId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CHIP_INVENTORY_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.get(`${API_URL}/clubs/${clubId}/chip-inventory`, config);

    dispatch({
      type: CHIP_INVENTORY_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CHIP_INVENTORY_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Setup initial chip inventory
export const setupChipInventory = (clubId, inventoryData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CHIP_INVENTORY_SETUP_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/clubs/${clubId}/chip-inventory/setup`,
      inventoryData,
      config
    );

    dispatch({
      type: CHIP_INVENTORY_SETUP_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CHIP_INVENTORY_SETUP_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Add chips to club inventory
export const addChipsToInventory = (clubId, chipData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CHIP_INVENTORY_ADD_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/clubs/${clubId}/chip-inventory/add`,
      chipData,
      config
    );

    dispatch({
      type: CHIP_INVENTORY_ADD_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CHIP_INVENTORY_ADD_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Remove chips from club inventory
export const removeChipsFromInventory = (clubId, chipData) => async (dispatch, getState) => {
  try {
    dispatch({ type: CHIP_INVENTORY_REMOVE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/clubs/${clubId}/chip-inventory/remove`,
      chipData,
      config
    );

    dispatch({
      type: CHIP_INVENTORY_REMOVE_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CHIP_INVENTORY_REMOVE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get chip inventory transaction history
export const getChipInventoryHistory = (clubId, params = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: CHIP_INVENTORY_HISTORY_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params,
    };

    const { data } = await axios.get(
      `${API_URL}/clubs/${clubId}/chip-inventory/history`,
      config
    );

    dispatch({
      type: CHIP_INVENTORY_HISTORY_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CHIP_INVENTORY_HISTORY_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get chip inventory summary
export const getChipInventorySummary = (clubId, params = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: CHIP_INVENTORY_SUMMARY_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params,
    };

    const { data } = await axios.get(
      `${API_URL}/clubs/${clubId}/chip-inventory/summary`,
      config
    );

    dispatch({
      type: CHIP_INVENTORY_SUMMARY_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CHIP_INVENTORY_SUMMARY_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Reconcile chip inventory
export const reconcileChipInventory = (clubId, notes = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: CHIP_INVENTORY_RECONCILE_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/clubs/${clubId}/chip-inventory/reconcile`,
      { notes },
      config
    );

    dispatch({
      type: CHIP_INVENTORY_RECONCILE_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CHIP_INVENTORY_RECONCILE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// ==================== STAFF CLUB ACCESS ====================

// Any 403 CLUB_INACTIVE response switches staff screens to the deactivated notice
export const setupClubInactiveInterceptor = (dispatch) =>
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const data = error.response?.data;
      if (error.response?.status === 403 && data?.code === CLUB_INACTIVE_CODE) {
        dispatch({
          type: CLUB_ACCESS_STATUS,
          payload: { blocked: true, message: data.message, inactiveClubs: data.inactiveClubs },
        });
      }
      return Promise.reject(error);
    },
  );

// Polled so the notice appears on deactivation and clears on reactivation
export const checkClubAccessStatus = () => async (dispatch, getState) => {
  const token = getState().adminLogin?.userInfo?.token;
  if (!token) {
    return;
  }

  try {
    const { data } = await axios.get(`${API_URL}/admins/club-status`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch({ type: CLUB_ACCESS_STATUS, payload: data });
  } catch (error) {
    // Network/auth errors are handled elsewhere; keep the last known status
  }
};
